import { useState, useEffect } from "react";
import "./ExploreProduct.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";
import Breadcrums from "../../components/breadcrums_v2/Breadcrums";
import FallbackImg from "../../components/FallbackImg";
import ApiService from "../../components/Api_services";
// import { useCategories } from "../../contexts/CategoryContext";

const ExploreProductv2 = () => {
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedCategoryState, setSelectedCategoryState] = useState("");

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    ApiService.getAllCategory().then((res) => {
      if (mounted && res.status === 200) setCategories(res.data.category);
      setLoading(false);
    });
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (categories && categories.length > 0) {
      setSelectedCategoryState(categories[0].code);
    }
  }, [categories]);

  const selectedCategoryData = (categories || []).find(
    (cat) => cat.code === selectedCategoryState,
  );

  return (
    <div className="exploreproduct">
      <Breadcrums />
      <div className="exploreproduct-content_v2">
        <div className="exploreproduct-maintitle-container_v2">
          <div className="exploreproduct-maintitle_v2">
            <div>PRODUCTS</div>
            <div className="searchbar-exploreproduct_v2">
              <input
                type="text"
                placeholder="Search product"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div
                className="searchbar-exploreproduct-remove_v2"
                style={{
                  visibility: search ? "visible" : "hidden",
                  pointerEvents: search ? "auto" : "none",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setSearch("");
                }}
              >
                &#x2715;
              </div>
              <Search color={"#717182"} size={16} style={{ width: "40px" }} />
            </div>
          </div>
        </div>
        <div className="exploreproduct-main_v2">
          {loading ? (
            <div className="loading-container">
              <div>Loading categories...</div>
            </div>
          ) : // ) : categories.length > 0 ? (
          categories && categories.length > 0 ? (
            <>
              <div className="exploreproduct-title-container_v2">
                <ul>
                  {categories.map((category) => (
                    <li
                      key={category.code}
                      onClick={() => setSelectedCategoryState(category.code)}
                      className={
                        selectedCategoryState === category.code &&
                        search.trim() === ""
                          ? "exploreproduct-active_v2"
                          : "exploreproduct-inactive_v2"
                      }
                    >
                      <div className="exploreproduct-emptyspace_v2"></div>
                      <div className="exploreproduct-title_v2">
                        {category.name}
                      </div>
                      <div className="category-nextsign">&gt;</div>
                    </li>
                  ))}
                </ul>
              </div>

              {selectedCategoryData && (
                <div className="exploreproduct-allitem_v2">
                  <div className="exploreproduct-subtitle_v2">
                    {search.trim() === ""
                      ? selectedCategoryData.name.toUpperCase()
                      : "SEARCH RESULTS"}
                  </div>
                  <div className="exploreproduct-item-container_v2">
                    {search.trim() == "" ? (
                      selectedCategoryData.sub_categories.filter(
                        (subCategory) =>
                          subCategory.name
                            .toLowerCase()
                            .includes(search.trim().toLowerCase()),
                      ).length > 0 ? (
                        selectedCategoryData.sub_categories
                          .filter((subCategory) =>
                            subCategory.name
                              .toLowerCase()
                              .includes(search.trim().toLowerCase()),
                          )
                          .map((subCategory) => (
                            <Link
                              key={subCategory.code}
                              to={`/productlist?product=${subCategory.code}&search=1`}
                            >
                              <div className="exploreproduct-item_v2">
                                <div className="exploreproduct-item-frame_v2">
                                  <FallbackImg
                                    src={subCategory.photo_url}
                                    alt={subCategory.name}
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                                <span className="exploreproduct-item-name_v2">
                                  {subCategory.name}
                                </span>
                              </div>
                            </Link>
                          ))
                      ) : (
                        <div className="no-subcategories">
                          No product available
                        </div>
                      )
                    ) : (
                      categories.map((category) =>
                        category.sub_categories.filter((subCategory) =>
                          subCategory.name
                            .toLowerCase()
                            .includes(search.trim().toLowerCase()),
                        ).length > 0 ? (
                          category.sub_categories
                            .filter((subCategory) =>
                              subCategory.name
                                .toLowerCase()
                                .includes(search.trim().toLowerCase()),
                            )
                            .map((subCategory) => (
                              <Link
                                key={subCategory.code}
                                to={`/productlist?product=${subCategory.code}`}
                              >
                                <div className="exploreproduct-item_v2">
                                  <div className="exploreproduct-item-frame_v2">
                                    <FallbackImg
                                      src={subCategory.photo_url}
                                      alt={subCategory.name}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                  <span className="exploreproduct-item-name_v2">
                                    {subCategory.name}
                                  </span>
                                </div>
                              </Link>
                            ))
                        ) : (
                          <></>
                        ),
                      )
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="no-categories">No product category available</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExploreProductv2;
